import { TaskActionsInfo } from '../types/task';
import {
  ContactIcon,
  CreateEstimateIcon,
  CreateRepairProjectIcon,
  FollowUpOnEstimateIcon,
  InvoiceIcon,
  MakePhoneCallIcon,
  OtherIcon,
  SendEmailIcon,
  SendMessageIcon,
  SignFormIcon,
  TakePhotoIcon,
  WriteNoteIcon,
  CalendarIcon,
  DocumentIcon,
  SubmitIcon,
} from '~/assets/icons';

export const TASK_ACTION_INFO: TaskActionsInfo = [
  'send_email',
  'sign_form',
  'take_photos',
  'write_note',
  'send_message',
  'make_phone_call',
  'schedule',
  'other',
  'create_estimate',
  'contact',
  'documentation',
  'follow_up_on_estimate',
  'invoice',
  'submit_documentation',
  'create_repair_project',
];

export const TASK_ACTION_ICON = [
  SendEmailIcon,
  SignFormIcon,
  TakePhotoIcon,
  WriteNoteIcon,
  SendMessageIcon,
  MakePhoneCallIcon,
  CalendarIcon,
  OtherIcon,
  CreateEstimateIcon,
  ContactIcon,
  DocumentIcon,
  FollowUpOnEstimateIcon,
  InvoiceIcon,
  SubmitIcon,
  CreateRepairProjectIcon,
];
